<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Kontak Paguyuban', url: app_url+'/kontak-paguyuban', status: true }
                ]"
            ></breadcrumb>
            <section id="detail-news" class="section withPad">
                <div class="container">
                    <div class="row-grid">
                        <div class="col-grid-60">
                            <div class="item_detail_news">
                                <div class="title_main_news">
                                    <div class="wrap-label flex flex-center">
                                        <span
                                            ><img
                                                src="/images/icon_calendar.png"
                                                alt="calendar"
                                        /></span>
                                        <p class="tx-grey date-post">
                                            29 Agustus 2019
                                        </p>
                                    </div>
                                    <div class="title-promo">
                                        <h2 class="tx-black">
                                            Mengenal Aldi Hadi Wiyanto, PIC Community Honda Riau
                                        </h2>
                                        <p class="sub_community">
                                            Surabaya Honda Community
                                        </p>
                                        <div
                                            class="btn-share"
                                            :class="{ active: show }"
                                        >
                                            <div class="shares">
                                                <a
                                                    href="https://www.facebook.com/"
                                                    target="_blank"
                                                    ><i
                                                        class="ion-social-facebook"
                                                    ></i
                                                ></a>
                                                <a
                                                    href="http://twitter.com/"
                                                    target="_blank"
                                                    ><i
                                                        class="ion-social-twitter"
                                                    ></i
                                                ></a>
                                                <a href="#" target="_blank"
                                                    ><i
                                                        class="ion-social-whatsapp"
                                                    ></i
                                                ></a>
                                            </div>
                                            <a @click="showShare" class="sharebtn"
                                                ><span
                                                    ><i
                                                        class="ion-android-share-alt"
                                                    ></i></span
                                            ></a>
                                        </div>
                                    </div>
                                </div><!--end.title_main_news-->
                                <div class="img-detail-news">
                                    <img src="/images/detail_paguyuban.png" />
                                </div>
                                <div class="isi-main-news">
                                    <p>Di Riau, nama Aldi Hadi Wiyanto Saputra terkenal dikalangan komunitas Honda.</p>
<p>
Pasalnya, Aldi sudah dua tahun menjabat sebagai PIC Community Honda wilayah Riau.</p>
<p>
"Sudah dua tahun menjabat sebagai PIC Community Honda di Riau, tentu saja banyak pengalaman yang sudah saya jalani," bukanya.</p>
<p>
Pria kelahiran Purwakarta, 20 Januari 1996 sudah bergabung di komunitas mulai tahun 2014 sampai sekarang.</p>
<p>
Aldi juga pernah bergabung di komunitas Musik dan perkusi.</p>
<p>
"Yang membuat tertarik join di komunitas karena di komunitas kita bsa banyak mengenal orang, menambah wawasan, mengenal struktural komunitas dan mengunjungi banyak tempat dengan rombongan," katanya.</p>
<p>
"Karena sebelum join dengan komunitas saya lebih sering touring sendiri, tetapi setelah join dengan komunitas serasa lebih rame dan suasana kekeluargaan yang begitu hangat," sambungnya.</p>
<p>
Semenjak menjadi PIC, Aldi mengatakan sedikit kesulitan lantaran banyak member yang usianya lebih tua dibandingkan dirinya.</p>
<p>
"Pengalaman saya bergabung di komunitas Honda saya sangat senang, walaupun awalnya cukup kesulitan karena selain ini baru, banyak dari rekan-rekan komunitas yang usianya jauh lebih tua di bandingkan saya," ucapnya.</p>
<p>
"Namun berkat support dan kerjasama dari rekan" Bikers, hal sulit jadi terasa mudah, dan saya nyaman dan senang bergabung di komunitas Honda," tambahnya.</p>
<p>
Kemudian Aldi juga pernah terlibat hampir di semua kegiatan komunitas Honda.</p>
<p>
"Banyak kegiatan yang saya jalani, mulai dari touring, bakti sosial, camping, gathering, kopdar, perayaan anniversary club, Honda Bikers Day Regional Sumatera dan yang paling Wow adalah ketika saya bisa bergabung di kegiatan tahunan Bikers Honda yaitu Honda Bikers Day Nasional, terlebih ketika saya bsa hadir di Banyuwangi untuk pertama kalinya," sebutnya.</p>
<p>
Saat ini Aldi membawahi 46 komunitas Honda di Riau dengan total member sekitar 570 orang.</p>
<p>
"Agar komunitas tetap loyal, saya melakukan pendekatan secara langsung dengan menjalin kerjasama. Saya pun menjelaskan bahwa antara kami dan komunitas itu adalah partner dan bukan sponsor," kata Aldi.</p>
                                </div>
                            </div><!--end.item_detail_news-->
                            <div class="related_rows">
                                <RelatedVertical></RelatedVertical>
                            </div>
                        </div>

                        <div class="col-grid-40">
                            <SosokBrader></SosokBrader>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import SosokBrader from "../news/SosokBrader";
import RelatedVertical from "../news/RelatedVertical";
import { isMobile } from "mobile-device-detect";

export default {
    components: {
        breadcrumb: BreadCrumb,
        SosokBrader,
        RelatedVertical,
    },
    data() {
        return {
            show: false,
            mobile: false,
            tlength: 25
        };
    },
    created() {
        this.mobile = isMobile;
    },
    methods: {
        showShare() {
            this.show = !this.show;
            console.log(this.show);
        }
    }
};
</script>

<style scoped lang="scss">
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    margin-top: 15px;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
@media all and (max-width:767px){
  .title-promo h2{
    font-size:24px;
  }
}
</style>
